import React, { useContext } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Button,
  MenuItem,
  Fab
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import { DrawerContext } from '../contexts/DrawerContext';
import { MdNightlightRound } from "react-icons/md";
import { WiDaySunny } from "react-icons/wi";

const pages = ['Home','About Me','Skills','Projects','Education','Socials'];

const Appbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const open = Boolean(anchorElNav);

  const {toggleDrawer, toggleTheme, theme} = useContext(DrawerContext);

  const handleScroll = (e)=>{
    document.getElementById(e.target.textContent).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }

  React.useEffect(()=>{

  },[])
  return (
    <div>
      <AppBar>
        <Container>
          <Toolbar>
            <Fab sx={{display:{xs:'none',md:'flex'},mr:0,cursor:'pointer'}} color="primary" className='skill-badge'><SelfImprovementIcon /></Fab>
            <Typography
              sx={{
                mr:2,
                ml:2,
                display:{xs:'none',md:'flex'},
                fontFamily: 'monospace',
                fontWeight:700,
                letterSpacing:'.3rem',
                color:'inherit',
                textDecoration:'none'
              }}
            >SHARANG</Typography>
            <Box sx={{flexGrow:1, display:{xs:'flex',md:'none'}}}>
              <IconButton 
                size='large'
                color='inherit'
                onClick={(ev)=>setAnchorElNav(ev.target)}
                >
                <MenuIcon />
              </IconButton>
              <Menu
                open={open}
                anchorEl={anchorElNav}
                onClose={()=>setAnchorElNav(null)}
                sx={{
                display:{xs:'block',md:'none'},
              }}>
                {pages.map((p)=><MenuItem key={p} onClick={handleScroll}>
                  <Typography>{p}</Typography>
                </MenuItem>)}
              </Menu>
            </Box>
            <SelfImprovementIcon sx={{display:{xs:'flex',md:'none'},mr:0,cursor:'pointer'}} onClick={toggleDrawer(true)} />
            <Typography
              sx={{
                mr:2,
                display:{xs:'flex',md:'none'},
                flexGrow:1,
                fontFamily:'monospace',
                fontWeight:700,
                letterSpacing:'.3rem',
                color:'inherit',
                textDecoration:'none'
              }} 
            >SHARANG</Typography>
            <Box sx={{flexGrow:1,display:{xs:'none',md:'flex'}}}>
              {pages.map((p)=><Button key={p} onClick={handleScroll} sx={{my:2,color:'white',display:'block'}}>{p}</Button>)}
            </Box>
            <Box sx={{flexGrow:0}}>
              <div className='sa-button skill-badge' >SA</div>
            </Box>
            <Box sx={{
              marginLeft: "0.6em",
              fontSize:"2em",
              cursor: 'pointer'
            }}>
              <div onClick={toggleTheme}>
                  {theme.mode === "day" ? <WiDaySunny /> : <MdNightlightRound />}
              </div>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  )
}

export default Appbar